let tierKeyCounter = 0;

export function buildEmptyPlanForm() {
  return { name: '', maxDepth: 3, isDefault: false, isActive: true, tiers: [] };
}

export function buildPlanFormFromDto(dto) {
  if (!dto) return buildEmptyPlanForm();
  return {
    name: dto.name, maxDepth: dto.maxDepth, isDefault: dto.isDefault, isActive: dto.isActive,
    tiers: dto.tiers.map((tier) => ({ ...tier, key: `tier-${tierKeyCounter++}` })),
  };
}

export function buildEmptyTier() {
  return { key: `tier-${tierKeyCounter++}`, depth: 0, type: 'cpa', amount: '0', currency: 'USD', minLots: '' };
}
